The page of position profiles and their corresponding cursors.

This list may be empty.
